// src/pages/AllUsers.tsx
import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { getAllUsers } from "@/services/Users/getAllUser";
import { deleteUser } from "@/services/Users/deleteUser";
import { editUser } from "@/services/Users/editUser";

interface User {
  id: number;
  username: string;
  role: string;
  createdDate: string;
}

const { Option } = Select;

export const AllUsers: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [username, setUsername] = useState<string>("");
  const [role, setRole] = useState<string>("user");
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const data = await getAllUsers();
      setUsers(data.users);
      console.log(data.users);
    } catch (err: any) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEdit = (user: User) => {
    setEditingUser(user);
    setUsername(user.username);
    setRole(user.role);
    setModalVisible(true);
  };

  const handleDelete = async (id: number) => {
    try {
      await deleteUser(id);
      message.success("Kullanıcı silindi");
      fetchUsers();
    } catch (err: any) {
      message.error(err.message);
    }
  };

  const handleSave = async () => {
    if (!editingUser) return;
    try {
      await editUser(editingUser.id, { username, role });
      message.success("Kullanıcı güncellendi");
      setModalVisible(false);
      setEditingUser(null);
      fetchUsers();
    } catch (err: any) {
      message.error(err.message);
    }
  };

  const columns: ColumnsType<User> = [
    { title: "ID", dataIndex: "id", key: "id" },
    { title: "Username", dataIndex: "username", key: "username" },
    { title: "Role", dataIndex: "role", key: "role" },
    { title: "Created Date", dataIndex: "createdDate", key: "createdDate" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Edit
          </Button>
          <Button type="link" danger onClick={() => handleDelete(record.id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>All Users</h2>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={users}
        loading={loading}
      />

      <Modal
        title="Edit User"
        visible={modalVisible}
        onOk={handleSave}
        onCancel={() => setModalVisible(false)}
        okText="Save"
      >
        <Input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          style={{ marginBottom: 10 }}
        />
        <Select value={role} onChange={(value) => setRole(value)} style={{ width: "100%" }}>
          <Option value="user">User</Option>
          <Option value="admin">Admin</Option>
        </Select>
      </Modal>
    </div>
  );
};
